export function Combos(list, n = 0, result = [], current = []) {
  if (n === list.length) {
    result.push(current);
  } else {
    list[n].forEach((item) => Combos(list, n + 1, result, [...current, item]));
  }

  return result;
}

export function Permutator(inputArr) {
  const result = [];

  const permute = (arr, m = []) => {
    if (arr.length === 0) {
      result.push(m);
    } else {
      for (let i = 0; i < arr.length; i++) {
        let curr = arr.slice();
        let next = curr.splice(i, 1);
        permute(curr.slice(), m.concat(next));
      }
    }
  };

  permute(inputArr);

  return result;
}
